export default __webpack_public_path__ + "static/media/hot-drink.35a07f9a.png";